var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdPlanPerkEmails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5A54E0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A41CC"
    },
    d: "M512,256c0-4.146-0.107-8.266-0.302-12.363l-88.853-88.853l-14.479,10.225l-60.561-60.561 l-15.93,15.929L271.498,60l-31,55.667l98.402,98.402l-12.452,8.793L225.476,121.891l-21.92,21.92l97.197,97.197L92.144,388.333 l119.892,119.892C226.321,510.698,241.008,512,256,512C397.385,512,512,397.385,512,256z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.5,
    y: 60,
    style: {
      fill: "#FFFFFF"
    },
    width: 31,
    height: 55.667
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 255.57,
    y: 60,
    style: {
      fill: "#EBEBF0"
    },
    width: 15.926,
    height: 55.667
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.659,
    y: 85.326,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 461.4087 417.4393)",
    style: {
      fill: "#EBEBF0"
    },
    width: 31,
    height: 55.666
  })), /*#__PURE__*/React.createElement("rect", {
    x: 167.002,
    y: 97.669,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 252.5806 330.9594)",
    style: {
      fill: "#FFFFFF"
    },
    width: 55.665,
    height: 30.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.14,
    y: 168.98,
    style: {
      fill: "#FFDA00"
    },
    width: 327.71,
    height: 219.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.57,
    y: 168.98,
    style: {
      fill: "#FFB600"
    },
    width: 164.28,
    height: 219.36
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF04A"
    },
    d: "M419.856,388.333L297.532,273.901c-23.372-21.864-59.693-21.864-83.065,0L92.144,388.333H419.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA00"
    },
    d: "M297.532,273.901c-11.798-11.037-26.895-16.494-41.961-16.388v130.82h164.285L297.532,273.901z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB600"
    },
    d: "M92.144,168.977l118.368,110.732c25.598,23.946,65.378,23.946,90.976,0l118.368-110.732 L92.144,168.977L92.144,168.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9500"
    },
    d: "M255.571,168.977v128.682c16.487,0.106,33.006-5.872,45.916-17.95l118.368-110.732L255.571,168.977 L255.571,168.977z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FA5D0F"
    },
    cx: 388,
    cy: 186.32,
    r: 47
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D84C0F"
    },
    d: "M388,139.323c-0.295,0-0.587,0.017-0.881,0.022V233.3c0.294,0.005,0.586,0.022,0.881,0.022 c25.957,0,47-21.043,47-47S413.957,139.323,388,139.323z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdPlanPerkEmails);
export default __webpack_public_path__ + "static/media/ad-plan-perk-emails.e8f90eb9f4f1378a29bbcafc34c469fa.svg";
export { ForwardRef as ReactComponent };